// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import VueLazyload from 'vue-lazyload'  // 引入图片懒加载
import VueCropper from 'vue-cropper'    // 裁剪图片
import imageViewer from '@/components/vue-imageViewer-master' // 图片查看

import router from './router'
import store from './store'             // 引入vuex
import Api from './Api/Api.js'

// 新版拖拽图片
import draggable from "vuedraggable";
Vue.use(draggable)

import { LoadFunc } from '@/assets/js/Utils.js'
Vue.prototype.$Loading    = LoadFunc;

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/img/error.jpg'),
  loading: require('./assets/img/loading.jpg'),
  attempt: 1
})

Vue.use(ElementUI);
Vue.use(VueCropper);
Vue.use(imageViewer);
Vue.config.productionTip = false;
Vue.prototype.$api = Api.Api;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js